/* eslint-disable */
import React from 'react';
import { Box, Typography, Skeleton } from '@mui/material';

const InfoPill = ({ label, value, loading }) => (
  <Box sx={{ textAlign: 'left' }}>
    <Typography sx={{ fontSize: '12px', fontWeight: 600, lineHeight: '32px', color: '#94A2B8', letterSpacing: '0px', textTransform: 'uppercase' }}>
      {label}
    </Typography>
    <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#385576', mt: '-6px' }}>
      {loading
        ? <Skeleton variant="text" width={90} sx={{ display: 'inline-block' }} />
        : value}
    </Typography>
  </Box>
);

export default InfoPill;
